<div class="headerStyle">
  <div class="row">
    <div class="col-12">{{multiplierHeader?.customerName}}</div>
  </div>
  <div class="row col-12">
    <div>{{multiplierLabel.customerNumberLbl?multiplierLabel.customerNumberLbl:multiplierPlan.customerNumberLbl}}: </div>
    <div>{{multiplierHeader?.customerNumber}}</div>
  </div>
  <div class="row col-12">
    <div>{{multiplierLabel.territoryCodeLbl?multiplierLabel.territoryCodeLbl:multiplierPlan.territoryCodeLbl}}: </div>
    <div>{{multiplierHeader?.territoryCode}}</div>
  </div>
  <div class="row col-12">
    <div>{{multiplierHeader?.addressLine1}}</div>
    <div>{{multiplierHeader?.city}}, {{multiplierHeader?.state}} {{multiplierHeader?.zipCode}}</div>
  </div>
</div>
<div class="row info">
  <div class="col-12 paddingZero">**{{multiplierLabel.multiplierLbl1?multiplierLabel.multiplierLbl1:multiplierPlan?.multiplierLbl1}}</div>
  <div class="col-12 paddingZero">**{{multiplierLabel.multiplierLbl2?multiplierLabel.multiplierLbl2:multiplierPlan?.multiplierLbl2}}: {{multiplierPlan.dateText}}</div>
</div>

<br />
<section>
  <!--[height]="470"-->
  <kendo-grid [data]="multiplierGridView"
              class="multiplierGridCls"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="false"
              [sort]="multiplierGridstate.sort"
              (sortChange)="multiplierGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }"
              [pageSize]="multiplierGridstate.take"
              [skip]="multiplierGridstate.skip"
              [columnMenu]="false"
              (pageChange)="multiplierGridPageChange($event)"
              (dataStateChange)="multiplierDataStateChange($event)"
              [filter]="multiplierGridstate.filter"
              [loading]="multiplierLoading">
    <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-button-display btn-web">
        <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateMultiplierExcel()">
          {{multiplierLabel.exportToExcelLbl?multiplierLabel.exportToExcelLbl:multiplierPlan.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generateMultiplierPDF()">
          {{multiplierLabel.exportToPdfLbl?multiplierLabel.exportToPdfLbl:multiplierPlan.exportToPdfLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>
      <input placeholder="Search in all columns..."
             kendoTextBox
             (input)="onFilter($event.target.value)" class="pwaSearch" />
    </ng-template>

    <kendo-grid-column field="itemGroup" title="{{multiplierLabel.itemGroupLbl?multiplierLabel.itemGroupLbl:multiplierPlan.itemGroupLbl}}"
                       [filterable]="true" media="(min-width: 1051px)">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="itemGroupDescription" title="{{multiplierLabel.descriptionLbl?multiplierLabel.descriptionLbl:multiplierPlan.descriptionLbl}}"
                       [filterable]="true" media="(min-width: 1051px)">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="itemGroupMultiplier" title="{{multiplierLabel.itemGroupMultiplierLbl?multiplierLabel.itemGroupMultiplierLbl:multiplierPlan.itemGroupMultiplierLbl}}" [filterable]="true" media="(min-width: 1051px)">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem="dataItem">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem="dataItem">
        {{dataItem?.itemGroupMultiplier}}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(max-width: 1050px)" title="Customer Multiplier Plan">
      <ng-template kendoGridCellTemplate let-dataItem>       
        <div class="row">
          <div class="col-10 cmp-desc">
            {{dataItem.itemGroup}}-{{dataItem.itemGroupDescription}}
          </div>
          <div class="col-2 paddingZero">
            {{dataItem.itemGroupMultiplier}}
          </div>
        </div>
      </ng-template>
    </kendo-grid-column>


    <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>-->
  </kendo-grid>

</section>

<div class="row info">
  <div class="col-xs-12 col-sm-12 paddingZero">{{multiplierLabel.multiplierLbl3?multiplierLabel.multiplierLbl3:multiplierPlan.multiplierLbl3}}</div>
  <div class="col-xs-12 col-sm-12 paddingZero">{{multiplierLabel.multiplierLbl4?multiplierLabel.multiplierLbl4:multiplierPlan.multiplierLbl4}}</div>
  <div class="col-xs-12 col-sm-12 paddingZero">{{multiplierLabel.multiplierLbl5?multiplierLabel.multiplierLbl5:multiplierPlan.multiplierLbl5}}</div>
</div>
